import { IAudit, ITemplate, ITemplateNode } from '@alberta/konexi-shared';

import { AuditDto } from '../../models/swodoc/audit-dto.model';
import { AuditNodeDto } from '../../models/swodoc/audit-node-dto.model';
import { AuthService } from '../auth.service';

export class AuditBaseService {
  constructor(private _auth: AuthService) {}

  public async createAudit(template: ITemplate, prefillData = []): Promise<IAudit> {
    const account = await this._auth.getAccount();
    const copyNewAuditNodeFromTemplateNode = (templateNode: ITemplateNode, parentId: string) => {
      return AuditNodeDto.createByTemplate(templateNode, parentId, prefillData, account);
    };
    const audit = new AuditDto();
    audit.archived = false;
    audit.templateId = template._id;
    audit.displayType = template.defaultAuditDisplayType;
    audit.auditNodes = [];
    audit.createdUtc = new Date().toISOString();
    audit.updatedUtc = new Date().toISOString();
    audit.optimizedFormularValidation = true;
    audit.images = [];

    copyNewAuditNodeFromTemplateNodeRec(template.templateNodes, audit.auditNodes);

    audit.auditNodes.forEach(auditNode => {
      if (auditNode.children) {
        auditNode.children = flatten(auditNode.children);
        auditNode.children.forEach(childAuditNode => {
          switch (childAuditNode.nodeType_Id) {
            case 'condition':
              childAuditNode.conditionTriggerId = childAuditNode.parentId;
              flatten(childAuditNode.children ? childAuditNode.children : []).forEach(subNode => {
                subNode.conditionId = childAuditNode.id;
              });
              break;
            case 'repeater':
              flatten(childAuditNode.children ? childAuditNode.children : []).forEach(subNode => {
                subNode.repeaterId = childAuditNode.id;
              });
              break;
            default:
          }
          if (childAuditNode.nodeType_Id !== 'repeater') {
            delete childAuditNode.children;
          }
        });
      }
    });

    function flatten(data) {
      const result = [];
      function flattenRec(_data, _result) {
        _data.forEach(element => {
          if (!_result.find(f => f.id === element.id)) {
            _result.push(element);
          }
          if (element.nodeType_Id === 'repeater') {
            flattenRec(element.children ? element.children : [], element.children);
          } else {
            flattenRec(element.children ? element.children : [], _result);
          }
        });
      }
      flattenRec(data, result);
      return result;
    }

    function copyNewAuditNodeFromTemplateNodeRec(templateNodes, auditNodes, parentId?: string) {
      templateNodes.forEach(templateNode => {
        const auditNode = copyNewAuditNodeFromTemplateNode(templateNode, parentId);
        if (templateNode.children) {
          copyNewAuditNodeFromTemplateNodeRec(templateNode.children, auditNode.children, auditNode.id);
        }
        auditNodes.push(auditNode);
      });
    }

    return audit;
  }
}
